import React from 'react';
// import clsx from 'clsx';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {Field, reduxForm, getFormValues} from 'redux-form';

import {withStyles} from '@mui/styles';
import {
  Grid,
  FormControl,
  FormLabel,
  FormGroup,
  FormControlLabel,
  Checkbox,
  // Switch,
} from '@mui/material';
import SaveIcon from '@mui/icons-material/Save';
import CloseIcon from '@mui/icons-material/Close';
import DomainVerificationIcon from '@mui/icons-material/DomainVerification';
// import PlaylistAddCheckIcon from '@mui/icons-material/PlaylistAddCheck';
import RotateLeftIcon from '@mui/icons-material/RotateLeft';
import MenuItem from '@mui/material/MenuItem';
import CheckCircle from '@mui/icons-material/CheckCircle';
import Cancel from '@mui/icons-material/Cancel';

import {GMN, GMN_PATH} from '../../../../common/commonConst.js';
import {commonOperations} from '../../../../reducks/common';
import {attachorderOperations} from '../../../../reducks/attachorder';
import {PositiveButton} from '../../../atoms/Buttons/PositiveButton.js';
import DangerButton from '../../../atoms/Buttons/DangerButton.js';
import IconButton from '@mui/material/IconButton';
import NegativeButton from '../../../atoms/Buttons/NegativeButton.js';
import {/* renderTextField,*/ renderSelect} from '../../../atoms/CustomPart.js';

import PaperPart from '../../../atoms/PaperPart.js';
import MainContainer from '../../../organisms/MainContainer.js';
import withRouter from '../../../organisms/withRouter.js';
import ApprovalComment from '../../../organisms/Approval/ApprovalComment/index.js';
import ApprovalStatus from '../../../organisms/Approval/ApprovalStatus/index.js';
import CustomBreadcrumbs from '../../../molecules/Breadcrumbs.js';
import WarningMessageArea from '../../../molecules/WarningMessageArea.js';

import './index.css';
import esriConfig from 'https://js.arcgis.com/4.31/@arcgis/core/config.js';
import esriId from 'https://js.arcgis.com/4.31/@arcgis/core/identity/IdentityManager.js';
import Map from 'https://js.arcgis.com/4.31/@arcgis/core/Map.js';
import MapView from 'https://js.arcgis.com/4.31/@arcgis/core/views/MapView.js';
import FeatureLayer from 'https://js.arcgis.com/4.31/@arcgis/core/layers/FeatureLayer.js';
import Search from 'https://js.arcgis.com/4.31/@arcgis/core/widgets/Search.js';
import Expand from 'https://js.arcgis.com/4.31/@arcgis/core/widgets/Expand.js';
import SketchViewModel from 'https://js.arcgis.com/4.31/@arcgis/core/widgets/Sketch/SketchViewModel.js';
import ScaleBar from 'https://js.arcgis.com/4.31/@arcgis/core/widgets/ScaleBar.js';
import GraphicsLayer from 'https://js.arcgis.com/4.31/@arcgis/core/layers/GraphicsLayer.js';

const styles = (theme) => ({
  'paperPart': {
    'height': 'calc(100% - 54px)',
    'min-height': '400px',
    'margin': '0',
    'position': 'relative',
    '& > div': {
      'height': '100%',
      'padding': '0',
    },
  },
  'viewDiv': {
    'height': '100%',
    'padding': '4px',
  },
  'infoDiv': {
    'display': 'block',
    'padding': '12px 4px 8px 4px',
    'box-sizing': 'border-box',
    '& > .title': {
      'display': 'block',
      'margin-bottom': '8px',
      'padding': '0 4px 4px',
      'border-bottom': 'outset 1px #999',
      'font-size': '1rem',
      'font-weight': 'bold',
    },
    '& > .area': {
      width: '100%',
      padding: '4px',
    },
    '& > .row': {
      'display': 'flex',
      'flex-direction': 'row',
      'padding': '4px',
      '& > button': {
        'flex': '1',
        'border-style': 'solid',
        'border-width': '1px',
        'border-image': 'none',
        'margin': '0 4px',
      },
    },
    '& > .houseSummary': {
      'margin': '4px',
      '& * table': {
        'tableLayout': 'fixed',
        'width': '100%',
        'margin': '4px 0',
        'borderCollapse': 'collapse',
        '& * ': {
          'border': 'solid 1px #999',
          'text-align': 'center',
        },
      },
    },
    '& > .ope': {
      'border-top': 'inset 1px #999',
      'margin-top': '4px',
      'padding-top': '8px',
    },
  },
  'searchDiv': {
    'display': 'block',
    'padding': '12px 4px 8px 4px',
    'box-sizing': 'border-box',
    'white-space': 'nowrap',
    '& > .title': {
      'display': 'block',
      'margin-bottom': '8px',
      'padding': '0 4px 4px',
      'border-bottom': 'outset 1px #999',
      'font-size': '1rem',
      'font-weight': 'bold',
    },
    '& * .MuiFormGroup-root': {
      '& > label': {
        'height': '1.5em',
        'padding': '0 1em',
      },
    },
    '& .searchSelect': {
      'marginTop': '12px',
    },
  },
  'tableArea': {
    'width': 'auto',
    'white-space': 'nowrap',
    '& > .tableDiv': {
      'display': 'block',
      'padding': '12px 4px 8px',
      'box-sizing': 'border-box',
      '& > .title': {
        'display': 'block',
        'margin-bottom': '4px',
        'padding': '0 4px 4px',
        'border-bottom': 'outset 1px #999',
        'font-size': '1rem',
        'font-weight': 'bold',
      },
      '& > .areaList': {
        'display': 'flex',
        'flex-direction': 'row',
        '& * table': {
          'table-layout': 'fixed',
          'margin': '1px',
          'border-spacing': '0',
          'border-collapse': 'collapse',
          '& * .dataType': {
            'height': '2.3em',
            '& > th': {
              'background-color': 'darkslategray',
              'borderBottom': 'solid 1px white',
            },
            '& > th.blank': {
              'backgroundColor': 'white',
              'border': 'none',
            },

          },
          '& * th': {
            'border': 'solid 1px #999',
            'padding': '1px 4px',
            'background-color': 'black',
            'color': 'white',
            '& > select': {
              'width': '100%',
              'height': '2em',
              'border': 'solid 1px lightgrey',
              'background-color': 'transparent',
              'color': 'white',
              'border-radius': '2px',
              'textAlign': 'center',
              'fontWeight': 'bold',
              '& > option': {
                'background-color': 'darkslategray',
              },
            },
          },
          '& * th.itaku': {
            'min-width': '8em',
          },
          '& * td': {
            'border': 'solid 1px #999',
            'padding': '1px 4px',
            'text-align': 'right',
          },
          '& * td.itaku': {
            'text-align': 'center',
          },
          '& * td.itaku1': {
            'background-color': '#FF000050',
          },
          '& * td.itaku2': {
            'background-color': '#00FFFF50',
          },
          '& * td.itaku3': {
            'background-color': '#FFFF0050',
          },
        },
      },
    },
  },
  'button': {
    width: '8em',
    margin: '0px 16px 6px',
  },
  'fields': {
    'margin': '0px 10px 15px 10px',
  },
  'resultsDiv': {
    'display': 'none',
    'position': 'absolute',
    'top': '60px',
    'left': '20px',
    'height': 'calc(100% - 90px)',
    'background-color': '#FFFFFFDD',
    'border-radius': '4px',
    'padding': '4px',
    '& > .resultGuide': {
      'min-width': '20em',
      '& * .alignRight': {
        'text-align': 'right',
      },
    },
    '& > .houseSummary': {
      '& > table': {
        'minWidth': '24em',
        'margin': '4px 0',
      },
      '& *': {
        'border': 'solid 1px #999',
        'borderCollapse': 'collapse',
        'text-align': 'center',
      },
    },
    '& > #resultsListDiv': {
      'height': 'calc(100% - 98px)',
      '& > #resultsList': {
        '& > calcite-pick-list-item': {
          'margin': '0px 0px 1px',
          'box-sizing': 'border-box',
          'display': 'block',
          'align-items': 'stretch',
          'background-color': 'var(--calcite-ui-foreground-1)',
          'font-size': 'var(--calcite-font-size--1)',
          'line-height': '1rem',
          'color': 'var(--calcite-ui-text-1)',
          '--tw-shadow': '0 1px 0 var(--calcite-ui-border-3)',
          '--tw-shadow-colored': '0 1px 0 var(--tw-shadow-color)',
          'box-shadow': 'var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow)',
          'transition': 'background-color var(--calcite-animation-timing)',
          'animation': 'calcite-fade-in var(--calcite-animation-timing)',
          'border': 'outset 1px #DDD',
          'border-radius': '4px',
        },
        '& * .top': {
          'position': 'relative',
          'padding': '6px 32px 6px 0px',
          'border-bottom': 'inset 1px #999',
          '& span > *': {
            'vertical-align': 'middle',
            'cursor': 'pointer',
          },
          '& > button': {
            'position': 'absolute',
            'top': '4px',
            'right': '4px',
            'padding': '2px 6px',
            'cursor': 'pointer',
            'background-color': 'white',
            'border': 'outset 1px white',
            'border-radius': '2px',
          },
          '& > button:hover': {
            'opacity': '0.7',
          },
        },
        '& * .info': {
          'padding': '4px 0',
          '& > span': {
            'display': 'block',
            'padding': '0 1em',
          },
        },
      },
    },
  },
});

const valueInfo = [{
  value: '0',
  symbol: {
    type: 'simple-fill',
    color: '#505050C0',
  },
}, {
  value: '1',
  symbol: {
    type: 'simple-fill',
    color: '#FF0000C0',
  },
}, {
  value: '2',
  symbol: {
    type: 'simple-fill',
    color: '#00FFFFC0',
  },
}, {
  value: '3',
  symbol: {
    type: 'simple-fill',
    color: '#FFFF00C0',
  },
}];

/**
 * 委託エリア設定画面
 * 画面ID:SXXXXXX
 */
class Container extends React.Component {
  constructor(props) {
    super(props);
    const _list = [
      {gmnName: GMN.MENU.name, href: GMN_PATH.MENU},
      {gmnName: GMN.GOAL_INVEST_SETTING_MESH.name, href: ''},
    ];
    this.state = {
      buttonDisabled: true,
      buttonDisabled2: true,
      // tabIndex: 1,
      transitionList: _list,
      warningMessages: [],
    };

    esriConfig.portalUrl = 'https://ec2-54-199-192-186.ap-northeast-1.compute.amazonaws.com/portal';
    esriId.registerToken({
      server: 'https://ec2-54-199-192-186.ap-northeast-1.compute.amazonaws.com/server/rest/services',
      token: 'hn7DFqjz0z12yk_Il1b5IkEeB61-VGcuTl3ytL9jZam_co8L103xDCww0tUu6RtFeKxAZPBEUGC3eAMjrsnOMGGRScRTc-TeGS5LVO8M6UfsXZMDujgZU4sz9ILbdVoAX5F8NaCe1Jedsb3Z5Pst4eihb3ULepjsW3DUgXGXgBw.',
    });
  }

  /**
   * 初期処理
   */
  async componentDidMount() {
    try {
      this.props.doSetReferenceMode(false);

      const featureLayer = new FeatureLayer({
        url: 'https://ec2-54-199-192-186.ap-northeast-1.compute.amazonaws.com/server/rest/services/Hosted/Mesh/FeatureServer',
        // portalItem: {
        //   id: '09039fa3ae78477693485648db8598c2',
        // },
        opacity: 0.3,
        id: 'meshLayer',
        renderer: {
          type: 'unique-value',
          // field: "GRID_LEVEL",
          field: 'contractor',
          defaultSymbol: {
            type: 'simple-fill',
            color: '#00000000',
            // color: "transparent"
          },
          uniqueValueInfos: valueInfo,
        },
      });

      const houseLayer = new FeatureLayer({
        url: 'https://ec2-54-199-192-186.ap-northeast-1.compute.amazonaws.com/server/rest/services/Hosted/House/FeatureServer',
        // portalItem: {
        //   id:"0c78294bbde84a06b6f94d2673f089be"
        // },
        minScale: 3000,
        // maxScale:50000
      });

      const countLayer = new FeatureLayer({
        url: 'https://ec2-54-199-192-186.ap-northeast-1.compute.amazonaws.com/server/rest/services/Hosted/Count/FeatureServer',
        // portalItem: {
        //  id:"fc0e40a9ac814c68b46556c25b0a8bbb"
        // },
        minScale: 25000,
        // maxScale:10000
      });

      const map = new Map({
        basemap: 'topo',
        // basemap: 'streets',
        layers: [houseLayer, countLayer, featureLayer],
      });

      // WebMapを使ってMapViewを作成する
      const view = new MapView({
        container: 'viewDiv',
        center: [132.45583688403656, 34.38850970630322],
        popupEnabled: false,
        zoom: 8,
        map: map,
      });

      // 初期表示
      view.when(() => {
        featureLayer.when(() => {
          return featureLayer.queryExtent();
        }).then((response) => {
          // 単位メッシュの範囲で全体表示
          view.goTo(response.extent, {'duration': 2000});
        });
      });

      // マップクリック
      view.on('click', (event) => {
        view.hitTest(event).then((response) => {
          const graphic = response.results[0]?.graphic;
          if (graphic?.layer === featureLayer) {
            const queryParams = houseLayer.createQuery();
            queryParams.geometry = graphic.geometry;
            queryParams.spatialRelationship = 'contains';
            queryParams.where = '1 = 1';
            queryParams.returnGeometry = true;

            // クエリの実行
            houseLayer.queryFeatures(queryParams).then((graphics) => {
              let box = document.getElementById('resultsDiv');
              box.style.display = 'block';
              let info = document.getElementById('meshNo');
              info.innerHTML = Math.floor(graphic.attributes['oid'] / 100);
              let houseCount = document.getElementById('houseCount');
              houseCount.innerHTML = graphics.features.length + ' 件';
              let list = document.getElementById('resultsList');
              list.innerHTML = '';
              let input = document.getElementById('resultInput');
              input.addEventListener('click', () => {
              });
              let close = document.getElementById('resultClose');
              close.addEventListener('click', () => {
                houseCount.innerHTML = '';
                list.innerHTML = '';
                box.style.display = 'none';
              });
              graphics.features.forEach((result, index) => {
                const attributes = result.attributes;
                let tagNo = 'name_' + (index + 1);
                const item = document.createElement('calcite-pick-list-item');

                const topDiv = document.createElement('div');
                topDiv.classList.add('top');
                const rowName = document.createElement('span');
                rowName.innerHTML = '<input type="checkbox" id="' + tagNo + '" data-key=""/>';
                rowName.innerHTML += '<label for=' + tagNo + '>田中まち' + (index + 1) + ' 様</label>';
                const btnMap = document.createElement('button');
                btnMap.innerHTML = '⇒';
                btnMap.addEventListener('click', () => resultClickHandler(result));
                topDiv.appendChild(rowName);
                topDiv.appendChild(btnMap);
                item.appendChild(topDiv);

                const rowAddress = document.createElement('span');
                const rowPoint = document.createElement('span');
                const rowContractor = document.createElement('span');
                const rowPrev = document.createElement('span');
                const rowNext = document.createElement('span');
                const rowNextYear = document.createElement('span');
                const rowPref = document.createElement('span');
                let objectid = attributes['objectid'] % 3 + 1;

                rowAddress.innerHTML = [
                  '郵便番号', '都道府県名_漢字', '市区郡町村名_漢字', '大字通称名_漢字',
                ].map((item) => (attributes[item] || '').trim())
                    .join('') || '広島県広島市中区1-' + (index + 1);
                rowPoint.innerHTML = '供給地点特定番号： ' + (attributes['specificno'] || 'AAAAAAAAAAAAAAAAAAAAAA');
                rowContractor.innerHTML = '委託先固定： ' + ((objectid == 1) ? '保安協会':'工業組合').trim();
                rowPrev.innerHTML = ('前回委託エリア： 委託' + (objectid || '')).trim();
                rowNext.innerHTML = ('次回委託エリア： 委託' + (objectid || '')).trim();
                rowNextYear.innerHTML = ('次回調査年度： ' + 2026).trim();

                const infoDiv = document.createElement('div');
                infoDiv.classList.add('info');
                infoDiv.appendChild(rowAddress);
                infoDiv.appendChild(rowPoint);
                infoDiv.appendChild(rowContractor);
                infoDiv.appendChild(rowPrev);
                infoDiv.appendChild(rowNext);
                infoDiv.appendChild(rowNextYear);
                infoDiv.appendChild(rowPref);
                item.appendChild(infoDiv);
                document.getElementById('resultsList').appendChild(item);
              });
            });
          }
        });
      });

      // 結果リスト用のクリック処理
      let highlightSelect;
      function resultClickHandler(result) {
        if (result) {
          // 対象のポイントのポップアップを表示
          view?.popup?.open({
            features: [result],
            location: result?.geometry,
          });
          // 対象のポイントへ移動
          view.goTo(result);
        }

        // ハイライト表示
        if (highlightSelect) {
          highlightSelect.remove();
        }
        highlightSelect = houseLayer?.highlight(result?.graphic);
      }

      const search = new Search({
        view: view,
        // autoSelect: false,
        includeDefaultSources: false,
        locationEnabled: false,
        popupEnabled: true,
        sources: [
          {
            url: 'https://geocode.arcgis.com/arcgis/rest/services/World/GeocodeServer',
            singleLineFieldName: 'SingleLine',
            outFields: ['Addr_type', 'Type', 'Place_addr', 'PlaceName'],
            // outFields: ['*'],
            name: '住所',
            placeholder: '住所',
          },
          {layer: houseLayer, searchFields: ['SpecificNo'], name: '供給地点特定番号', placeholder: '供給地点特定番号', zoomScale: 1000},
          {layer: houseLayer, searchFields: ['SpecificNo'], name: 'お客さま名（カナ）', placeholder: 'お客さま名（カナ）', zoomScale: 1000},
        ],
      });
      view.ui.add(search, 'top-left');

      const selectExpand = new Expand({
        expandIcon: 'image-magnifying-glass',
        expandTooltip: '表示条件',
        expanded: true,
        view: view,
        content: document.getElementById('searchDiv'),
      });
      view.ui.add(selectExpand, 'top-left');

      view.ui.move('zoom', 'bottom-left');

      // スケールバー設定
      let scalebar = new ScaleBar({
        unit: 'metric',
        view: view,
      });
      view.ui.add(scalebar, 'bottom-left');

      const editExpand = new Expand({
        expandIcon: 'add-in-edit',
        expandTooltip: '委託エリア変更',
        expanded: false,
        view: view,
        content: document.getElementById('editArea'),
        group: 'right',
      });
      view.ui.add(editExpand, 'top-right');

      const tableExpand = new Expand({
        expandIcon: 'table',
        expandTooltip: '目標調査件数',
        expanded: false,
        view: view,
        content: document.getElementById('tableArea'),
        group: 'right',
      });
      view.ui.add(tableExpand, 'top-right');

      // add a GraphicsLayer for the sketches and the buffer
      const sketchLayer = new GraphicsLayer();
      view.map.addMany([sketchLayer]);

      // create the layerView's to add the filter
      let featureLayerView = null;
      featureLayer.when(() => {
        // loop through webmap's operational layers
        view.map.layers.forEach((layer, index) => {
          view
              .whenLayerView(layer)
              .then((layerView) => {
                if (layer.type === 'feature') {
                  featureLayerView = layerView;
                }
              })
              .catch(console.error);
        });
      });

      // use SketchViewModel to draw polygons that are used as a filter
      let sketchGeometry = null;
      const sketchViewModel = new SketchViewModel({
        layer: sketchLayer,
        view: view,
        pointSymbol: {
          type: 'simple-marker',
          style: 'circle',
          size: 10,
          color: [255, 255, 255, 0.8],
          outline: {
            color: [211, 132, 80, 0.7],
            size: 10,
          },
        },
        polygonSymbol: {
          type: 'simple-fill',
          color: '#ff000030',
          outline: {
            color: [255, 0, 0, 0.7],
            size: 4,
          },
        },
        defaultCreateOptions: {
          hasZ: false,
        },
      });

      sketchViewModel.on(['create'], (event) => {
        if (event.state == 'complete') {
          sketchGeometry = event.graphic.geometry;
          updateFilter();
        }
      });

      sketchViewModel.on(['update'], (event) => {
        if (event.toolEventInfo?.type.includes('stop')) {
          sketchGeometry = event.graphics[0].geometry;
          updateFilter();
        }
      });

      // draw geometry buttons - use the selected geometry to sktech
      document.getElementById('point-geometry-button').onclick = geometryButtonsClickHandler;
      document.getElementById('polygon-geometry-button').onclick = geometryButtonsClickHandler;

      function geometryButtonsClickHandler(event) {
        const geometryType = event.target.value;
        clearSelect();
        sketchViewModel.create(geometryType);
        return false;
      }

      // regist
      document.getElementById('registSelect').addEventListener('click', () => {
        let level = document.getElementsByName('area')[0].value;
        let editFeatures = selectFeatures.map((feature) => {
          feature.attributes['contractor'] = level;
          return feature;
        });
        featureLayer.applyEdits({
          updateFeatures: editFeatures,
        }).then((editsResult) => {
          console.log(editsResult);
        }).catch((error) => {
          console.log('error = ', error);
        });
        document.getElementById('clearSelect').click();
      });

      // remove
      document.getElementById('clearSelect').addEventListener('click', () => {
        highlights?.forEach((hl) => hl.remove());
        highlights = [];
        selectFeatures = [];
        clearSelect();
      });

      function clearSelect() {
        sketchGeometry = null;
        sketchLayer.removeAll();
        sketchViewModel.cancel();
      }

      // set the geometry filter on the visible FeatureLayerView
      let selectFeatures = [];
      let highlights = [];

      function updateFilter() {
        const query = {
          geometry: sketchGeometry,
          outFields: ['*'],
        };
        featureLayer.queryFeatures(query).then((results) => {
          results.features.forEach((feature) => selectFeatures.push(feature));
          highlights.push(featureLayerView.highlight(results.features));
          clearSelect();
        });
      }
    } catch (error) {
      this.props.doShowMessage({
        message: 'CS0001',
        action: () => {
          this.props.history.push('/login');
        },
      });
    }
  }

  /**
    * 終了処理
    */
  async componentWillUnmount() {
    this.props.reset();
    this.props.doClearOrderList();
    this.props.doClearOrder();
  }

  doDecision = () => {
    this.props.doShowMessage({
      message: {
        id: 'BFY000009I',
        values: ['確定'],
      },
    });
  };

  doFullDelete = () => {
    this.props.doShowMessage({
      message: {
        id: 'BFY000009I',
        values: ['取消'],
      },
    });
  };

  doSyoninShinsei = () => {
    this.props.doShowMessage({
      message: {
        id: 'BFY000009I',
        values: ['承認申請'],
      },
    });
  };

  /**
   * 承認ダイアログの表示
   * @param {string} type
   */
  displayApprovalComment = (type) => {
    this.setState({
      showApprovalCommentModal: true,
      approvalType: type,
    });
  };

  /**
 * 承認ダイアログを閉じる
 */
  closeApprovalComment = () => {
    this.setState({
      showApprovalCommentModal: false,
    });
  };

  /**
   * 承認状況画面の表示
   */
  displayApproval = () => {
    this.setState({
      showApprovalModal: true,
    });
  };

  /**
   * 承認状況画面画面を閉じる
   */
  closeApproval = () => {
    this.setState({
      showApprovalModal: false,
    });
  };

  /**
   * フッタボタン
   * @return {JSX.Element}
   */
  renderFooterBtn() {
    return (
      <Grid
        container
        justifyContent="center"
        alignItems="flex-end"
        spacing={1}
      >
        <Grid key="decisionButton" item>
          <PositiveButton
            id="decisionButton"
            onClick={()=> {
              this.doDecision('1');
            }}
            variant="contained"
            startIcon={<CheckCircle />}
          >
            <span>確定</span>
          </PositiveButton>
        </Grid>
        <Grid key="cancelButton" item>
          <DangerButton
            id="cancelButton"
            onClick={this.doFullDelete}
            variant="contained"
            startIcon={<Cancel />}
          >
            <span>取消</span>
          </DangerButton>
        </Grid>
        <Grid key="applicationButton" item>
          <PositiveButton
            id="applicationButton"
            onClick={this.doSyoninShinsei}
            variant="contained"
            startIcon={<SaveIcon />}
          >
            <span>承認申請</span>
          </PositiveButton>
        </Grid>
        <Grid key="approvalButton" item>
          <PositiveButton
            id="approvalButton"
            onClick={()=> {
              this.displayApprovalComment('1');
            }}
            variant="contained"
            startIcon={<CheckCircle />}
          >
            <span>承認</span>
          </PositiveButton>
        </Grid>
        <Grid key="rejectButton" item>
          <DangerButton
            id="rejectButton"
            onClick={()=> {
              this.displayApprovalComment('2');
            }}
            variant="contained"
            startIcon={<Cancel />}
          >
            <span>否決</span>
          </DangerButton>
        </Grid>
        <Grid key="stateButton" item>
          <PositiveButton
            id="stateButton"
            onClick={this.displayApproval}
            variant="contained"
          >
            <span>承認状況</span>
          </PositiveButton>
        </Grid>
      </Grid>
    );
  };

  render() {
    const {
      classes,
      // generalPurposeMap,
      // reset,
      // handleSubmit,
      // values,
      //  userInfo
    } = this.props;

    // フッタボタンを生成
    const footerBtn = this.renderFooterBtn();

    return (
      <form noValidate autoComplete="off" className={classes.root}>
        <MainContainer
          props={this.props}
          footerBtn={footerBtn}>
          <CustomBreadcrumbs key="keyBreadcrumbs" items={this.state.transitionList}/>
          <Grid key="keySCA1001Msg" item xs={12}>
            <WarningMessageArea messages={this.state.warningMessages}/>
          </Grid>
          <PaperPart className={classes.paperPart}>
            <div id="viewDiv" className={classes.viewDiv}></div>
            <div id="editArea" className="editArea-container esri-widget--panel">
              <div id="infoDiv" className={(classes.infoDiv) + ' esri-widget'}>
                <span className="title">委託エリア変更</span>
                <Grid key="area" item xs={12} sm={12} className="area">
                  <Field
                    id="area"
                    name="area"
                    component={renderSelect}
                    label="委託エリア"
                    fullWidth
                    required={true}
                    value ='-1'
                    defaultValue={'-1'}
                    initialValue={'-1'}
                    validate={[
                    ]}
                    InputProps={{
                      readOnly: false,
                    }}
                  >
                    <MenuItem value={0}>{'中電ＮＷ'}</MenuItem>
                    <MenuItem value={1}>{'委託１'}</MenuItem>
                    <MenuItem value={2}>{'委託２'}</MenuItem>
                    <MenuItem value={3}>{'委託３'}</MenuItem>
                    <MenuItem value={-1}>{'設定なし'}</MenuItem>
                  </Field>
                </Grid>
                <Grid key="area" item xs={12} sm={12} className="row">
                  <button
                    className="esri-widget--button esri-icon-map-pin geometry-button"
                    id="point-geometry-button"
                    value="point"
                    title="ポイント"
                  >&nbsp;ポイント</button>
                  <button
                    className="esri-widget--button esri-icon-polygon geometry-button"
                    id="polygon-geometry-button"
                    value="polygon"
                    title="ポリゴン"
                  >&nbsp;ポリゴン</button>
                </Grid>
                <Grid key="area" item xs={12} sm={12} className='houseSummary'>
                  <span style={{'text-decoration': 'underline'}}>対象口数</span>
                  <span style={{'padding-left': '1em'}}>27件</span>
                  <div>
                    <table>
                      <tr>
                        <th>2026</th>
                        <th>2027</th>
                        <th>2028</th>
                        <th>2029</th>
                      </tr>
                      <tr>
                        <td>11件</td>
                        <td>10件</td>
                        <td>0件</td>
                        <td>6件</td>
                      </tr>
                    </table>
                  </div>
                </Grid>
                <Grid key="area" item xs={12} sm={12} className="row ope">
                  <PositiveButton
                    id="registSelect"
                    className={classes.button}
                    variant="contained"
                    startIcon={<SaveIcon />}
                  >
                    <span>設定</span>
                  </PositiveButton>
                  <NegativeButton
                    id="clearSelect"
                    className={classes.button}
                    variant="contained"
                    startIcon={<RotateLeftIcon />}
                  >
                    <span>クリア</span>
                  </NegativeButton>
                </Grid>
              </div>
            </div>
            <div id="tableArea" className={classes.tableArea}>
              <div id="tableDiv" className='tableDiv'>
                <span className="title">目標調査件数</span>
                <Grid className="areaList">
                  <Grid key="sub" item xs={12} sm={6}>
                    <table>
                      <thead>
                        <tr className='dataType'>
                          <th colSpan="1" className='blank'></th>
                          <th colSpan="4">合計</th>
                        </tr>
                        <tr>
                          <th rowSpan="2" className='itaku'>広島県</th>
                          <th colSpan="2">目標</th>
                          <th colSpan="2">調整値</th>
                        </tr>
                        <tr>
                          <th>比率</th>
                          <th>調査口数</th>
                          <th>比率</th>
                          <th>調査口数</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td className="itaku itaku1">委託１</td>
                          <td>50%</td>
                          <td>50,000</td>
                          <td>45%</td>
                          <td>45,000</td>
                        </tr>
                        <tr>
                          <td className="itaku itaku2">委託２</td>
                          <td>30%</td>
                          <td>30,000</td>
                          <td>32%</td>
                          <td>32,000</td>
                        </tr>
                        <tr>
                          <td className="itaku itaku3">委託３</td>
                          <td>20%</td>
                          <td>20,000</td>
                          <td>23%</td>
                          <td>23,000</td>
                        </tr>
                      </tbody>
                    </table>
                  </Grid>
                  <Grid key="sub" item xs={12} sm={6}>
                    <table>
                      <thead>
                        <tr className='dataType'>
                          <th colSpan="4">
                            <select id="other" className="ME">
                              <option value="2026">2026年度</option>
                              <option value="2027">2027年度</option>
                              <option value="2028">2028年度</option>
                              <option value="2029">2029年度</option>
                            </select>
                          </th>
                        </tr>
                        <tr>
                          <th colSpan="2">目標</th>
                          <th colSpan="2">調整値</th>
                        </tr>
                        <tr>
                          <th>比率</th>
                          <th>調査口数</th>
                          <th>比率</th>
                          <th>調査口数</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>50%</td>
                          <td>50,000</td>
                          <td>45%</td>
                          <td>45,000</td>
                        </tr>
                        <tr>
                          <td>30%</td>
                          <td>30,000</td>
                          <td>32%</td>
                          <td>32,000</td>
                        </tr>
                        <tr>
                          <td>20%</td>
                          <td>20,000</td>
                          <td>23%</td>
                          <td>23,000</td>
                        </tr>
                      </tbody>
                    </table>
                  </Grid>
                </Grid>
                <Grid className="areaList">
                  <Grid key="sub" item xs={12} sm={6}>
                    <table>
                      <thead>
                        <tr>
                          <th rowSpan="2" className='itaku'>広島</th>
                          <th colSpan="2">目標</th>
                          <th colSpan="2">調整値</th>
                        </tr>
                        <tr>
                          <th>比率</th>
                          <th>調査口数</th>
                          <th>比率</th>
                          <th>調査口数</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td className="itaku itaku1">委託１</td>
                          <td>50%</td>
                          <td>5,000</td>
                          <td>40%</td>
                          <td>4,000</td>
                        </tr>
                        <tr>
                          <td className="itaku itaku2">委託２</td>
                          <td>30%</td>
                          <td>3,000</td>
                          <td>40%</td>
                          <td>4,000</td>
                        </tr>
                        <tr>
                          <td className="itaku itaku3">委託３</td>
                          <td>20%</td>
                          <td>2,000</td>
                          <td>20%</td>
                          <td>2,000</td>
                        </tr>
                      </tbody>
                    </table>
                  </Grid>
                  <Grid key="sub" item xs={12} sm={6}>
                    <table>
                      <thead>
                        <tr>
                          <th colSpan="2">目標</th>
                          <th colSpan="2">調整値</th>
                        </tr>
                        <tr>
                          <th>比率</th>
                          <th>調査口数</th>
                          <th>比率</th>
                          <th>調査口数</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>50%</td>
                          <td>5,000</td>
                          <td>40%</td>
                          <td>4,000</td>
                        </tr>
                        <tr>
                          <td>30%</td>
                          <td>3,000</td>
                          <td>40%</td>
                          <td>4,000</td>
                        </tr>
                        <tr>
                          <td>20%</td>
                          <td>2,000</td>
                          <td>20%</td>
                          <td>2,000</td>
                        </tr>
                      </tbody>
                    </table>
                  </Grid>
                </Grid>
                <Grid className="areaList">
                  <Grid key="sub" item xs={12} sm={6} className="">
                    <table>
                      <thead>
                        <tr>
                          <th rowSpan="2" className='itaku'>
                            <select id="other" className="ME">
                              <option value="1">福山</option>
                              <option value="2">廿日市</option>
                              <option value="3">東広島</option>
                            </select>
                          </th>
                          <th colSpan="2">目標</th>
                          <th colSpan="2">調整値</th>
                        </tr>
                        <tr>
                          <th>比率</th>
                          <th>調査口数</th>
                          <th>比率</th>
                          <th>調査口数</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td className="itaku itaku1">委託１</td>
                          <td >50%</td>
                          <td>5,000</td>
                          <td>45%</td>
                          <td>4,500</td>
                        </tr>
                        <tr>
                          <td className="itaku itaku2">委託２</td>
                          <td>30%</td>
                          <td>3,000</td>
                          <td>32%</td>
                          <td>3,200</td>
                        </tr>
                        <tr>
                          <td className="itaku itaku3">委託３</td>
                          <td>20%</td>
                          <td>2,000</td>
                          <td>23%</td>
                          <td>2,300</td>
                        </tr>
                      </tbody>
                    </table>
                  </Grid>
                  <Grid key="sub" item xs={12} sm={6} className="">
                    <table>
                      <thead>
                        <tr>
                          <th colSpan="2">目標</th>
                          <th colSpan="2">調整値</th>
                        </tr>
                        <tr>
                          <th>比率</th>
                          <th>調査口数</th>
                          <th>比率</th>
                          <th>調査口数</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td >50%</td>
                          <td>5,000</td>
                          <td>45%</td>
                          <td>4,500</td>
                        </tr>
                        <tr>
                          <td>30%</td>
                          <td>3,000</td>
                          <td>32%</td>
                          <td>3,200</td>
                        </tr>
                        <tr>
                          <td>20%</td>
                          <td>2,000</td>
                          <td>23%</td>
                          <td>2,300</td>
                        </tr>
                      </tbody>
                    </table>
                  </Grid>
                </Grid>
              </div>
            </div>
            <div id="searchDiv" className={classes.searchDiv}>
              <span className="title">表示条件</span>
              <Grid key="pref" className="searchSelect">
                <Field
                  id="pref"
                  name="pref"
                  component={renderSelect}
                  label="県"
                  fullWidth
                  required={true}
                  value ='5000'
                  defaultValue={'5000'}
                  initialValue={'5000'}
                  validate={[
                  ]}
                  InputProps={{
                    readOnly: false,
                  }}
                >
                  <MenuItem value={2000}>{'鳥取県'}</MenuItem>
                  <MenuItem value={3000}>{'島根県'}</MenuItem>
                  <MenuItem value={4000}>{'岡山県'}</MenuItem>
                  <MenuItem value={5000}>{'広島県'}</MenuItem>
                  <MenuItem value={6000}>{'山口県'}</MenuItem>
                </Field>
              </Grid>
              <Grid key="nwc" className="searchSelect">
                <Field
                  id="nwc"
                  name="nwc"
                  component={renderSelect}
                  label="NW事業所"
                  fullWidth
                  required={true}
                  value ='5100'
                  defaultValue={'5100'}
                  initialValue={'5100'}
                  validate={[
                  ]}
                  InputProps={{
                    readOnly: false,
                  }}
                >
                  <MenuItem value={5100}>{'広島'}</MenuItem>
                  <MenuItem value={5110}>{'福山'}</MenuItem>
                  <MenuItem value={5120}>{'尾道'}</MenuItem>
                  <MenuItem value={5130}>{'三次'}</MenuItem>
                  <MenuItem value={5140}>{'呉'}</MenuItem>
                  <MenuItem value={5160}>{'広島北'}</MenuItem>
                  <MenuItem value={5170}>{'廿日市'}</MenuItem>
                  <MenuItem value={5190}>{'東広島'}</MenuItem>
                  <MenuItem value={5250}>{'広島（矢野）'}</MenuItem>
                </Field>
              </Grid>
              <hr></hr>
              <Grid
                container
                justifyContent="flex-start"
                alignItems="flex-start"
                spacing={1}
              >
                <Grid key="year" item xs={12} sm={6}>
                  <FormControl className="year">
                    <FormLabel id="year">調査年度</FormLabel>
                    <FormGroup>
                      <FormControlLabel control={<Checkbox size="small" defaultChecked />} label="2026" />
                      <FormControlLabel control={<Checkbox size="small" defaultChecked />} label="2027" />
                      <FormControlLabel control={<Checkbox size="small" defaultChecked />} label="2028" />
                      <FormControlLabel control={<Checkbox size="small" defaultChecked />} label="2029" />
                      <FormControlLabel control={<Checkbox size="small" defaultChecked />} label="毎年調査" />
                    </FormGroup>
                  </FormControl>
                </Grid>
                <Grid key="consign" item xs={12} sm={6}>
                  <FormControl className="consign">
                    <FormLabel id="consign">委託エリア</FormLabel>
                    <FormGroup>
                      <FormControlLabel control={<Checkbox size="small" defaultChecked />} label="中電ＮＷ" />
                      <FormControlLabel control={<Checkbox size="small" defaultChecked />} label="委託１" />
                      <FormControlLabel control={<Checkbox size="small" defaultChecked />} label="委託２" />
                      <FormControlLabel control={<Checkbox size="small" defaultChecked />} label="委託３" />
                      <FormControlLabel control={<Checkbox size="small" defaultChecked />} label="設定なし" />
                    </FormGroup>
                  </FormControl>
                </Grid>
              </Grid>
              <hr></hr>
              <FormControl className="changed">
                <FormLabel id="changed">変更箇所</FormLabel>
                <FormGroup>
                  <FormControlLabel control={<Checkbox size="small" />} label="変更分のみ" />
                </FormGroup>
              </FormControl>
            </div>
            <div id="resultsDiv" className={(classes.resultsDiv) + ' esri-widget--panel'}>
              <div className="resultGuide">
                <Grid container>
                  <Grid key="list" item xs={4}>
                    <span style={{'font-weight': 'bold', 'padding-left': '.5em', 'text-decoration': 'underline'}}>メッシュ番号</span>
                    <span style={{'display': 'block', 'text-align': 'center'}} id="meshNo"></span>
                  </Grid>
                  <Grid key="list" item xs={6} className='alignRight'>
                    <PositiveButton
                      id="resultInput"
                      variant="contained"
                      startIcon={<DomainVerificationIcon />}
                    >
                      <span>お客さま個別登録</span>
                    </PositiveButton>
                  </Grid>
                  <Grid key="list" item xs={2} className='alignRight'>
                    <IconButton id="resultClose" aria-label="閉じる">
                      <CloseIcon />
                    </IconButton>
                  </Grid>
                </Grid>
              </div>
              <div className='houseSummary'>
                <table>
                  <tr>
                    <th style={{'text-decoration': 'underline'}}>対象口数</th>
                    <th>2026</th>
                    <th>2027</th>
                    <th>2028</th>
                    <th>2029</th>
                  </tr>
                  <tr>
                    <td id="houseCount"></td>
                    <td>11件</td>
                    <td>10件</td>
                    <td>0件</td>
                    <td>6件</td>
                  </tr>
                </table>
              </div>
              <calcite-panel id="resultsListDiv">
                <calcite-pick-list id="resultsList"></calcite-pick-list>
              </calcite-panel>
            </div>
          </PaperPart>
        </MainContainer>
        <ApprovalComment
          openState={this.state.showApprovalCommentModal}
          tstk={false}
          approvalType={this.state.approvalType}
          // handleExec={handleSubmit(this.displaySpecification)}
          // handleExec={this.displayApprovalModal}
          handleClose = {this.closeApprovalComment}/>
        <ApprovalStatus
          openState={this.state.showApprovalModal}
          // handleExec={handleSubmit(this.displaySpecification)}
          // handleExec={this.displayApprovalModal}
          handleClose = {this.closeApproval}/>
      </form>
    );
  }
}

Container.propTypes = {
  classes: PropTypes.object,
  history: PropTypes.object,
  reset: PropTypes.func,
  doShowMessage: PropTypes.func,
  doClearOrderList: PropTypes.func,
  doClearOrder: PropTypes.func,
  doSetReferenceMode: PropTypes.func,
};

const mapStateToProps = (state) => {
  return {
    generalPurposeMap: state.common.generalPurposeMap,
    userInfo: state.auth.userInfo,
    orderList: state.attachorder.orderList,
    order: state.attachorder.order,
    initialValues: state.common.setInitValues,
  };
};

const mapDispatchToProps = {
  doShowMessage: commonOperations.doShowMessage,
  doGetOrderTypeList: attachorderOperations.doGetOrderTypeList,
  doSetOrderId: attachorderOperations.doSetOrderId,
  doDeleteProprietyOrder: attachorderOperations.doDeleteProprietyOrder,
  doClearOrderInfo: attachorderOperations.doClearOrderInfo,
  doSetStbType: commonOperations.doSetStbType,
  doClearOrderList: attachorderOperations.doClearOrderList,
  doRetrieveOrder: attachorderOperations.doRetrieveOrder,
  doClearOrder: attachorderOperations.doClearOrder,
  doSetReferenceMode: commonOperations.doSetReferenceMode,
  doSetOrderModifiedCondition:
    attachorderOperations.doSetOrderModifiedCondition,
  doSetInitValues: commonOperations.doSetInitValues,
};

const FORM_NAME = 'ProprietyJudgingList';

Container = reduxForm({
  form: FORM_NAME,
  destroyOnUnmount: false,
  enableReinitialize: true,
})(connect((state) => {
  return {
    values: getFormValues(FORM_NAME)(state),
  };
})(Container));

export default withStyles(styles)(
    connect(
        mapStateToProps,
        mapDispatchToProps,
    )(withRouter(Container)),
);
